/**
 * F-CAPTURE-009 — the Batches list's row state, status phrase and identifier,
 * single-sourced so the API can SORT by exactly what the web renders. Moved from
 * the web's BatchStatusBadge / formatters: a server-side sort over a value the
 * browser derives differently orders nothing the operator can see.
 */
import { batchStatusPhrase, } from "./status-vocabulary.js";
/**
 * F-048 / F-074 — collapse a batch's mixed-state breakdown to ONE row state.
 * Precedence: error > busy > awaiting_classify > ready > complete.
 */
export function batchDocState(bd) {
    if (bd.error > 0)
        return "error";
    if (bd.scanning + bd.keying + bd.exporting > 0)
        return "busy";
    if ((bd.awaitingClassify ?? 0) > 0)
        return "awaiting_classify";
    if (bd.ready > 0)
        return "ready";
    if (bd.total > 0 && bd.complete === bd.total)
        return "complete";
    return "ready";
}
/**
 * F-074/F-085 — the WORKABILITY axis: "awaiting_release" for a batch/hybrid
 * batch parked at the supervisor gate, "being_worked" when an operator holds a
 * doc, else "available".
 */
export function workItemStatus(batch) {
    const mode = batch.processingMode;
    const awaitingRelease = (mode === "batch" || mode === "hybrid") &&
        batch.currentStep?.primary === "supervisor";
    if (awaitingRelease)
        return "awaiting_release";
    return (batch.assignedCount ?? 0) > 0 ? "being_worked" : "available";
}
/** The Status cell's words; "" for a batch with no documents (the badge renders nothing). */
export function batchRowStatusText(bd, workability) {
    if (!bd || bd.total === 0)
        return "";
    return batchStatusPhrase(batchDocState(bd), workability);
}
/** The Batch cell's identifier: custom label, else displayId, else `B-<cuid prefix>`. */
export function batchRowLabel(batch) {
    if (batch.customDisplayLabel?.trim())
        return batch.customDisplayLabel;
    if (batch.displayId?.trim())
        return batch.displayId;
    return `B-${batch.id.slice(0, 6)}`;
}
const collator = new Intl.Collator("en", { sensitivity: "base", numeric: true });
/** Ascending order for rendered row text: case-insensitive, numeric-aware, empty last. */
export function compareBatchRowText(a, b) {
    if (a === "" || b === "")
        return a === b ? 0 : a === "" ? 1 : -1;
    return collator.compare(a, b);
}
//# sourceMappingURL=batch-row-state.js.map